// extracted by mini-css-extract-plugin
export var optionGrid = "_84-7";
export var optionList = "_84-6";
export var questionsBlock = "_84-9";
export var spacer = "_84-5";
export var stepCenteredContent = "_84-3";
export var stepInner = "_84-0";
export var stepInnerFullWidth = "_84-1";
export var stepInnerLockScroll = "_84-2";
export var stepTransitionFrame = "_84-4";
export var welcomeBlock = "_84-8";